import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import { Box,  HStack } from "@chakra-ui/react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import CoreService from "../../../services/CoreService";
import LocalStorageService from "../../../services/LocalStorageService";

import InboundQueueButtonStrip from "./InboundQueueButtonStrip";



const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";

const divStyle = {
  width: "100%",
  height: "calc(25vh)",

  margin: "5px",
  //border: '5px solid black'
};

const DelSwal = withReactContent(Swal);

export default class InboundQueueGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      formattedGridSchema: [],
      schema: null,
      gridData: [],
    };

    this.columnDefs = [
      {headerName: "Schema", field: "header.schemaId", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 300},
      {headerName: "Filter", field: "header.receiptFilterValue", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 250},
      {headerName: "Id", field: "header.receiptIdentifier", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 350, wrapText: true, autoHeight: true},
      {headerName: "Inbound Date", field: "header.eventDateTime", sortable: true, filter: true, resizable: true, minWidth: 150},
      {headerName: "Detail Id", field: "detail.receiptDetailIdentifier", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 100},
      {headerName: "Keys", field: "detail.detailKeys", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 300, wrapText: true, autoHeight: true, 
      cellRenderer: function(params) 
      {
        //var fieldKeys = params.value.map(p => p.glasschainId);
        return params.value.join(", ")
      }
    }  
  ];

    this.coreService = new CoreService();
    this.LocalStorageService = new LocalStorageService();

    this.refreshData = this.refreshData.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);

  }

  async componentDidMount()
  {
    await this.refreshData();
  }

  async componentDidUpdate(prevProps, prevState) {

    if (this.props.currentLocationId !== prevProps.currentLocationId)
    {
      await this.refreshData();
      return;
    }
    if (this.props.autoRefreshTriggerKey !== prevProps.autoRefreshTriggerKey) {
      if (this.props.suppressAutoRefresh) return; // don't refresh if we've supressed autorefresh for some reason
      await this.refreshData();
    }

  }

  async refreshData() 
  {
    this.setState({ isLoading: true });
    try 
    {
      var refreshDataResponse = await this.coreService.fetchInboundQueueOpenLines(this.props.userSession.currentLocationId,  this.props.userSession.gcid, this.props.userSession.token);
      if (refreshDataResponse.hasError)
      {
        this.props.onErrorPageRequest("Error fetching Inbound Queue. " + refreshDataResponse.messages.join(". "));
        return;
      }
      console.log("Inbound Queue data:")
      console.info(refreshDataResponse.dataResult);
      this.setState({gridData: refreshDataResponse.dataResult});    
    }
    finally 
    {
      this.setState({ isLoading: false });
    }
  }

  onSelectionChanged()
  {
    console.log("Changing selected row")
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData = selectedNodes[0].data;
    //var rowNode = selectedNodes[0];
    console.info(rowData);
    this.props.onSelectionChanged(rowData); 
  }


  async onDeleteRequest() {
      if (!this.props.currentRow) 
      {
        DelSwal.fire({ icon: "error", title: "Remove Inbound Queue Row", text: "Select a row to remove first!" });
        return;
      }
      DelSwal.fire
        (
          {
            icon: "question",
            title: "Remove Row?",
            text: "Confirm you want to permanently remove the existing row ",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel"
          }
        ).then(async (result) => {
          if (result.value) 
          {
            // delete the current line, and check if this removes the header (last line)
            await this.coreService.postInboundQueueReceiptLineByReceiptIdentifierLineIdentifier(this.props.currentRow.header.receiptIdentifier, this.props.currentRow.detail.receiptDetailIdentifier, this.props.userSession.gcid, this.props.userSession.token);
            await this.refreshData();
            this.props.onSelectionChanged(null);
            return DelSwal.fire({ icon: "success", text: "The Inbound Queue row has been permanently deleted." });
          }
        }
        );
    }
  


  // #region AgGrid functions

  onEditGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };


  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit(params)
  };

  // #endregion AgGrid functions

  render() {

    const columnDefs = this.state.gridSchema ? this.state.gridSchema : [];
    const gridData = this.state.gridData ? this.state.gridData : [{}];

    return (
      <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

        <HStack justify='space-between' marginLeft='5px'>
        <InboundQueueButtonStrip
          userSession={this.props.userSession}
          onMsgBoxRequest={this.props.onMsgBoxRequest}
          isLoading={this.state.isLoading}
          onRefreshGridRequest={this.refreshData}
          onDeleteRequest={this.onDeleteRequest}
          onMakeObservationRequest={this.props.onMakeObservationRequest}
          currentRow={this.props.currentRow}
        />

        </HStack>
        <div className="ag-theme-balham" style={divStyle}>
          <AgGridReact
            rowSelection="single"
            enableRangeSelection={false}
            pagination={true}
            columnDefs={this.columnDefs}
            rowData={gridData}
            animateRows={true}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
            onMakeObservationRequest={this.props.onMakeObservationRequest}
          />
        </div>

      </Box>

    );
  }
}
